<template>
  <v-container>
    <template>
      <v-stepper
        v-if="steps<maxSteps"
        v-model="steps"
        vertical
        elevation="0"
      >
        <!-- step 1 -->
        <v-stepper-step

          :complete="steps > 1"
          step="1"
          @click="steps>1?steps = 1:steps=steps"
        >
          Tipologia Ordine
          <small class="mt-1">
            Clip-On rif:<b> {{ order.desrif }}</b>
          </small>
        </v-stepper-step>

        <v-stepper-content step="1">
          <procedure-step1
            :step="steps"
            @nextStep="nextStep"
            @prevStep="prevStep"
            @viewCarnet="viewCarnet"
          />
        </v-stepper-content>
        <!-- step 2 -->
        <v-stepper-step
          :complete="steps > 2"
          step="2"
          @click="steps>2?steps = 2:steps=steps"
        >
          Colori
          <small
            class="mt-1"
          >
            {{ order.tipcol?'Multicolore':'Monocolore' }}
          </small>
        </v-stepper-step>

        <v-stepper-content step="2">
          <procedure-step2
            :step="steps"
            @nextStep="nextStep"
            @prevStep="prevStep"
          />
        </v-stepper-content>
      </v-stepper>

      <riepilogo
        v-if="steps==maxSteps"
        :step="steps"
        @nextStep="nextStep"
        @prevStep="prevStep"
        @stdOrder="$emit('stdOrder')"
      />
    </template>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import ProcedureStep1 from '@/views/Ordine/component/procedure/CLP/step1'
  import ProcedureStep2 from '@/views/Ordine/component/procedure/CLP/step2'
  import Riepilogo from '@/views/Ordine/component/procedure/CLP/riepilogo'

  export default {
    name: 'Workflow',
    components: { ProcedureStep1, ProcedureStep2, Riepilogo },
    props: {
      carnet: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        steps: 1,
        maxSteps: 3,
      }
    },
    computed: {
      ...mapState(['auth', 'order']),
      isMobile: function () {
        return this.$vuetify.breakpoint.xsOnly
      },

    },
    watch: {

    },
    mounted () {
      if (this.order.step > 1) {
        this.steps = this.order.step
      }
    },
    destroyed () {

    },
    methods: {
      viewCarnet () {
        this.$emit('viewCarnet')
      },
      nextStep (step) {
        console.log('nextstep', step)
        this.steps = step
        this.$forceUpdate()
      },
      prevStep (step) {
        console.log('prevstep', step - 1)
        this.steps = step - 1
        if (step === 0) {
          this.$emit('clearLinea')
        }
      },
    },
  }
</script>
